<script setup></script>


<template>
    <div class="bg-white rounded-xl shadow-[0_2px_10px_-3px_rgba(6,81,237,0.05)] border border-gray-100 p-6">
        <div v-if="$slots.header" class="flex justify-between items-center pb-4 border-b border-gray-100 mb-4">
            <slot name="header" />
        </div>
        <div>
            <slot />
        </div>
    </div>
</template>